import { clsx } from 'clsx'
import { ReactNode } from 'react'

export function ClientCard({
  className,
  title,
  step,
  children
}: {
  className?: string
  title: string
  step?: string
  children: ReactNode
}) {
  return (
    <div className={clsx('mx-auto w-full', className)}>
      <div className="mb-4 flex w-full justify-between">
        <h1 className="flex items-center gap-2 text-lg font-medium text-gray-800">
          {step && (
            <div className="text-md inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-blue-200 font-bold text-blue-500">
              {step}
            </div>
          )}
          {title}
        </h1>
      </div>

      <div className="w-full rounded-lg bg-white p-6 shadow-md">{children}</div>
    </div>
  )
}

type DocumentChecklistItemProps = {
  title: string
  description: string
  buttons?: ReactNode
  className?: string
  completed?: boolean
}
export function DocumentChecklistItem({
  title,
  description,
  buttons,
  completed,
  className
}: DocumentChecklistItemProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-start justify-between border-b border-gray-200 px-6 py-3 sm:flex-row sm:items-center',
        completed && 'bg-green-100',
        className
      )}
    >
      <div className="flex w-full flex-grow items-baseline">
        <span className="w-48 flex-shrink-0 text-lg font-semibold text-gray-900">{title}</span>
        <span className="flex-grow truncate text-right text-base text-gray-600 sm:text-left">
          {description}
        </span>
      </div>

      <div className="mt-2 flex w-full justify-end sm:ml-4 sm:mt-0 sm:block sm:w-auto sm:flex-shrink-0">
        {buttons}
      </div>
    </div>
  )
}
